/*!**************************Confidential and Proprietary*****************************
* File Name: index.ts
********************Copyright (c) Hyland Software, Inc. 1992-2023********************/

/**
 * Builds up DataChart.js, so that they may be used on the client side
 */

interface Window {
    DataChart: any;
    BarChart: any;
    PieChart: any;
}

RequireBundle();

function RequireBundle() {
    window.DataChart = require('./DataChart/DataChart.ts').DataChart;
    window.BarChart = require('./DataChart/BarChart.ts').BarChart;
    window.PieChart = require('./DataChart/PieChart.ts').PieChart;
}
